import React from "react"
import { ChevronLeft, ChevronRight, ChevronDown } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"

const Header = ({
  date,
  isSecondary = false,
  isLeft = true,
  months,
  handleDateSelect,
  openMonthPicker,
  changeMonth,
  datePickerSect,
  selectMonth,
}) => {
  return (
    <div className="flex items-center justify-between mb-3">
      {!isSecondary ? (
        <button
          onClick={() => changeMonth(-1)}
          className="p-1 hover:bg-gray-100 rounded cursor-pointer"
        >
          <ChevronLeft className="w-5 h-5 text-app-base-strong" />
        </button>
      ) : (
        <div className="w-7" />
      )}

      <div className="relative">
        <button
          onClick={() => handleDateSelect(isLeft)}
          className={`flex items-center gap-2 px-3 py-0.5 hover:bg-gray-100 rounded font-medium cursor-pointer ${
            openMonthPicker === (isLeft ? "left" : "right") ? "shadow-lg" : ""
          }`}
        >
          {months[date.getMonth()]} {date.getFullYear()}
          <ChevronDown className="w-4 h-4" />
        </button>

        <AnimatePresence>
          {openMonthPicker === (isLeft ? "left" : "right") && (
            <motion.div
              ref={datePickerSect}
              className={`absolute top-full mt-1 bg-white rounded-lg shadow-lg z-10 py-2 w-48 h-40 overflow-y-auto ${
                isLeft ? "left-0" : "right-0"
              }`}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              {months.map((month, index) => (
                <button
                  key={month}
                  onClick={() => selectMonth(index, isLeft)}
                  className="w-full px-4 py-2 text-left hover:bg-gray-100 cursor-pointer hover:text-app-base-strong transition-colors"
                >
                  {month} {date.getFullYear()}
                </button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {isSecondary ? (
        <button
          onClick={() => changeMonth(1)}
          className="p-1 hover:bg-gray-100 rounded cursor-pointer"
        >
          <ChevronRight className="w-5 h-5 text-app-base-strong" />
        </button>
      ) : (
        <div className="w-7" />
      )}
    </div>
  )
}

export default Header
